var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35147 8.7515C6.8201 8.28287 7.5799 8.28287 8.04853 8.7515L12 12.703L15.9515 8.7515C16.4201 8.28287 17.1799 8.28287 17.6485 8.7515C18.1172 9.22013 18.1172 9.97992 17.6485 10.4486L12.8485 15.2486C12.3799 15.7172 11.6201 15.7172 11.1515 15.2486L6.35147 10.4486C5.88284 9.97992 5.88284 9.22013 6.35147 8.7515Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.b3166d557686b8724af0086d2e4aa6b1.svg";
export { ForwardRef as ReactComponent };